module.exports = __webpack_public_path__ + "static/assets/a2ed866eb2db31b7583e7b52ee598246.svg";